import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const MinusCircle: FunctionalComponent<IIconProps> = ({ width = 20, height = 20, fill = '#666666' }) => (
  /*@ts-ignore*/
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.3977 5.39771 1.66674 10.0001 1.66674C14.6025 1.66674 18.3334 5.3977 18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334ZM10 16.6668C13.6819 16.6668 16.6667 13.6821 16.6667 10.0002C16.6667 6.31826 13.6819 3.33349 10 3.33349C6.31814 3.33349 3.33338 6.31826 3.33338 10.0002C3.33338 13.6821 6.31814 16.6668 10 16.6668ZM6.66675 9.16674C6.20651 9.16674 5.83341 9.53984 5.83341 10.0001C5.83341 10.4603 6.20651 10.8334 6.66675 10.8334H13.3334C13.7937 10.8334 14.1667 10.4603 14.1667 10.0001C14.1667 9.53984 13.7937 9.16674 13.3334 9.16674H6.66675Z"
      fill={fill}
    />
  </svg>
);

export default MinusCircle;
